// Système d'événements pour synchroniser les compteurs de notifications

export const NOTIFICATION_COUNT_UPDATED = 'notificationCountUpdated';

export function emitNotificationCountUpdate() {
  window.dispatchEvent(new CustomEvent(NOTIFICATION_COUNT_UPDATED));
}

export function onNotificationCountUpdate(callback: () => void) {
  window.addEventListener(NOTIFICATION_COUNT_UPDATED, callback);
  return () => window.removeEventListener(NOTIFICATION_COUNT_UPDATED, callback);
}
